import "./WorkflowTemplateTaskPanel.css";

import { ReactElement } from "react";

import { SearchWorkflowTemplateTasksResponseTask } from "../../models";
import { EmptyFlyoutPanel } from "../../widget";
import {
  DeleteTemplateTaskModal,
  TemplateTaskPanelLeft,
  TemplateTaskPanelRight,
  TemplateTaskPanelRightReadonly,
  TemplateTaskPanelTop,
} from "./components";
import { useWorkflowTemplateTaskPanel } from "./useWorkflowTemplateTaskPanel";

interface WorkflowTemplateTaskPanelProps {
  /*
    If undefined, then create
    If defined, then update
  */
  templateTask?: SearchWorkflowTemplateTasksResponseTask;
  currentStepUuid?: string; // For create panel
  show: boolean;
  onClose: () => void;
}

export const WorkflowTemplateTaskPanel = ({
  templateTask,
  currentStepUuid,
  show,
  onClose,
}: WorkflowTemplateTaskPanelProps): JSX.Element => {
  const {
    errors,
    canEditTask,
    workflowTemplate,
    organisationTypeSelectData,
    currentStepPhase,
    stepSelectData,
    phaseKeyDatesSelectData,

    currentTemplateTask,
    setCurrentTemplateTask,

    isTitleEditable,
    setIsTitleEditable,

    defaultDeadline,
    setDefaultDeadline,

    showDeleteTemplateTaskModal,
    setShowDeleteTemplateTaskModal,

    handleCloseTaskPanel,
    handleSubmit,
    isHandleSubmitLoading,
    mustSelectedOrgTypeVisibility,
    shouldHideOrganisationFields,
    isNewTask,
  } = useWorkflowTemplateTaskPanel({
    templateTask,
    currentStepUuid,
    onClose,
  });

  const content = (): ReactElement => {
    return (
      <div className="WorkflowTemplateTaskPanelContent">
        <TemplateTaskPanelTop
          handleCloseTaskPanel={handleCloseTaskPanel}
          handleClickDeleteTemplateTask={() => setShowDeleteTemplateTaskModal(true)}
          canEditTask={canEditTask}
          templateTask={templateTask}
        />
        <TemplateTaskPanelLeft
          errors={errors}
          canEditTask={canEditTask}
          workflowTemplate={workflowTemplate}
          isTitleEditable={isTitleEditable}
          setIsTitleEditable={setIsTitleEditable}
          currentTemplateTask={currentTemplateTask}
          setCurrentTemplateTask={setCurrentTemplateTask}
          handleSubmit={handleSubmit}
          handleCloseTaskPanel={handleCloseTaskPanel}
          isHandleSubmitLoading={isHandleSubmitLoading}
          isNewTask={isNewTask}
        />
        {canEditTask ? (
          <TemplateTaskPanelRight
            currentStepPhase={currentStepPhase}
            currentTemplateTask={currentTemplateTask}
            setCurrentTemplateTask={setCurrentTemplateTask}
            defaultDeadline={defaultDeadline}
            setDefaultDeadline={setDefaultDeadline}
            organisationTypeSelectData={organisationTypeSelectData}
            stepSelectData={stepSelectData}
            phaseKeyDatesSelectData={phaseKeyDatesSelectData}
            mustSelectedOrgTypeVisibility={mustSelectedOrgTypeVisibility}
            shouldHideOrganisationFields={shouldHideOrganisationFields}
          />
        ) : (
          <TemplateTaskPanelRightReadonly
            currentStepPhase={currentStepPhase}
            currentTemplateTask={currentTemplateTask}
            stepSelectData={stepSelectData}
            shouldHideOrganisationFields={shouldHideOrganisationFields}
          />
        )}
        <DeleteTemplateTaskModal
          show={showDeleteTemplateTaskModal}
          closePanel={handleCloseTaskPanel}
          closeModal={() => setShowDeleteTemplateTaskModal(false)}
          templateTask={templateTask}
        />
      </div>
    );
  };

  return <EmptyFlyoutPanel show={show} onClose={handleCloseTaskPanel} size="Large" contentChildren={content()} />;
};
